exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vehicle-details__image[data-v-4304eb9a]{max-width:100%\n}\n.vehicle-details__image-text[data-v-4304eb9a]{text-align:center;margin-bottom:20px\n}\n.vehicle-details__wrapper[data-v-4304eb9a]{background-color:#e5f4fa;border-radius:10px;padding:15px\n}\n.vehicle-details__heading[data-v-4304eb9a]{color:#192a44;margin-bottom:10px;font-weight:700;font-size:20px;line-height:20px\n}\n.vehicle-details__detail-item[data-v-4304eb9a]{display:grid;grid-template-columns:1fr 1fr;gap:15px\n}\n.vehicle-details__detail-item>span[data-v-4304eb9a]{font-weight:bold\n}\n.vehicle-details__detail-item+.vehicle-details__detail-item[data-v-4304eb9a]{margin-top:5px\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4304eb9a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/cms-content-slices/components/clean-air-zone/VehicleDetails.vue
// module id = /gSb
// module chunks = 32